import { DateTime } from 'luxon';

export const processDatesAssigments = (datesAssigments) => {
  const datesAssigmentsModel = {};
  const { attributes, relationships, id } = datesAssigments;
  if (id) {
    datesAssigmentsModel.id = id;
  }
  if (attributes.title) {
    datesAssigmentsModel.title = attributes.title;
  }
  if (attributes.f_entrada) {
    datesAssigmentsModel.operationEntry = DateTime.fromSQL(attributes.f_entrada).toISODate();
  }
  if (attributes.f_firma_deseada) {
    datesAssigmentsModel.operationSignature = DateTime.fromSQL(attributes.f_firma_deseada).toISODate();
  }
  if (attributes.f_firma_financiera) {
    datesAssigmentsModel.financesSignature = DateTime.fromSQL(attributes.f_firma_financiera).toISODate();
  }
  if (attributes.f_firma_notario) {
    datesAssigmentsModel.notarySignature = DateTime.fromISO(attributes.f_firma_notario).setLocale('es').toFormat("yyyy-MM-dd'T'HH:mm:ss.SSS");
  }
  /* relationships */
  if (relationships.colaborador &&
    relationships.colaborador.data &&
    relationships.colaborador.data.id) {
    datesAssigmentsModel.colaborador = relationships.colaborador.data.id;
  }
  if (relationships.analista &&
    relationships.analista.data &&
    relationships.analista.data.id) {
    datesAssigmentsModel.analistaDDC = relationships.analista.data.id;
  }
  if (relationships.analista_drc &&
    relationships.analista_drc.data &&
    relationships.analista_drc.data.id) {
    datesAssigmentsModel.analistaDRC = relationships.analista_drc.data.id;
  }
  if (relationships.juridico &&
    relationships.juridico.data &&
    relationships.juridico.data.id) {
    datesAssigmentsModel.juridico = relationships.juridico.data.id;
  }
  if (relationships.cancela &&
    relationships.cancela.data &&
    relationships.cancela.data.id) {
    datesAssigmentsModel.cancela = relationships.cancela.data.id;
  }
  if (relationships.comercial &&
    relationships.comercial.data &&
    relationships.comercial.data.id) {
    datesAssigmentsModel.comercial = relationships.comercial.data.id;
  }
  if (relationships.financiero &&
    relationships.financiero.data &&
    relationships.financiero.data.id) {
    datesAssigmentsModel.financiero = relationships.financiero.data.id;
  }
  if (relationships.formaliza &&
    relationships.formaliza.data &&
    relationships.formaliza.data.id) {
    datesAssigmentsModel.formaliza = relationships.formaliza.data.id;
  }
  return datesAssigmentsModel;
};

export const processOperationIncluded = (operation, included) => {
  const relationships = operation.relationships;
  const pledges = [];
  const clients = [];
  let datesAssigments = {};
  let volume = {};
  let expenses = {};
  let prereport = {};
  let plazoPeriodo = {};
  const documents = [];
  const letras = [];
  const cesiones = [];
  let report = {};
  let notary = {};
  let fichaComercial = {};
  let state = {};
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'node--pledge') {
        if (relationships &&
          relationships.pledge &&
          relationships.pledge.data &&
          relationships.pledge.data.length > 0) {
          relationships.pledge.data.forEach((b) => {
            if (b.id === rel.id) {
              pledges.push(rel);
            }
          });
        }
      }
      if (rel.type === 'node--client') {
        if (relationships &&
          relationships.clients &&
          relationships.clients.data &&
          relationships.clients.data.length > 0) {
          relationships.clients.data.forEach((c) => {
            if (c.id === rel.id) {
              clients.push(rel);
            }
          });
        }
      }
      if (rel.type === 'node--date_assignement') {
        if (relationships &&
          relationships.dates_assigments &&
          relationships.dates_assigments.data &&
          relationships.dates_assigments.data.id === rel.id) {
          datesAssigments = processDatesAssigments(rel);
        }
      }
      if (rel.type === 'taxonomy_term--status') {
        if (relationships &&
          relationships.state &&
          relationships.state.data &&
          relationships.state.data.id === rel.id) {
          state = rel;
        }
      }
      if (rel.type === 'node--business_card') {
        if (relationships &&
          relationships.ficha_comercial &&
          relationships.ficha_comercial.data &&
          relationships.ficha_comercial.data.id === rel.id) {
          fichaComercial = rel;
        }
      }
      if (rel.type === 'node--expenses') {
        if (relationships &&
          relationships.expenses &&
          relationships.expenses.data &&
          relationships.expenses.data.id === rel.id) {
          expenses = rel;
        }
      }
      if (rel.type === 'taxonomy_term--date') {
        if (relationships &&
          relationships.plazo_periodo &&
          relationships.plazo_periodo.data &&
          relationships.plazo_periodo.data.id === rel.id) {
          plazoPeriodo = rel;
        }
      }
      if (rel.type === 'node--volume') {
        if (relationships &&
          relationships.volume &&
          relationships.volume.data &&
          relationships.volume.data.id === rel.id) {
          volume = rel;
        }
      }
      if (rel.type === 'node--prereport') {
        if (relationships &&
          relationships.prereport &&
          relationships.prereport.data &&
          relationships.prereport.data.id === rel.id) {
          prereport = rel;
        }
      }
      if (rel.type === 'node--document') {
        if (relationships &&
          relationships.documents &&
          relationships.documents.data &&
          relationships.documents.data.length > 0) {
          relationships.documents.data.forEach((c) => {
            if (c.id === rel.id) {
              documents.push(rel);
            }
          });
        }
      }
      if (rel.type === 'node--report') {
        if (relationships &&
          relationships.report &&
          relationships.report.data &&
          relationships.report.data.id === rel.id) {
          report = rel;
        }
      }
      if (rel.type === 'node--notary') {
        if (relationships &&
          relationships.notario_operacion &&
          relationships.notario_operacion.data &&
          relationships.notario_operacion.data.id === rel.id) {
          notary = rel;
        }
      }
      if (rel.type === 'node--instancia_letra') {
        if (relationships &&
          relationships.letras_operation &&
          relationships.letras_operation.data &&
          relationships.letras_operation.data.length > 0) {
          relationships.letras_operation.data.forEach((c) => {
            if (c.id === rel.id) {
              letras.push(rel);
            }
          });
        }
      }
      if (rel.type === 'node--cesion') {
        if (relationships &&
          relationships.cesiones &&
          relationships.cesiones.data &&
          relationships.cesiones.data.length > 0) {
          relationships.cesiones.data.forEach((c) => {
            if (c.id === rel.id) {
              cesiones.push(rel);
            }
          });
        }
      }
    });
    return {
      clients,
      datesAssigments,
      state,
      pledges,
      expenses,
      volume,
      prereport,
      documents,
      letras,
      cesiones,
      report,
      notary,
      plazoPeriodo,
      fichaComercial,
    };
  }
  return {};
};

export const processOperation = (operation, included = {}) => {
  const operationModel = {};
  const { attributes, relationships, id } = operation;
  operationModel.included = included;
  if (id) {
    operationModel.id = id;
  }
  if (attributes.title) {
    operationModel.title = attributes.title;
  }
  if (attributes.draft) {
    operationModel.draft = attributes.draft;
  }
  if (attributes.pre_approval) {
    operationModel.preApproval = attributes.pre_approval;
  }
  if (attributes.last_user) {
    operationModel.lastUser = attributes.last_user;
  }
  if (attributes.interes_demora) {
    operationModel.interesDemora = attributes.interes_demora;
  }
  if (relationships.producto_cliente &&
    relationships.producto_cliente.data &&
    relationships.producto_cliente.data.id) {
    operationModel.clienteProducto = relationships.producto_cliente.data.id;
  }
  if (relationships.rango_cliente &&
    relationships.rango_cliente.data &&
    relationships.rango_cliente.data.id) {
    operationModel.clienteRango = relationships.rango_cliente.data.id;
  }
  if ('importe_cliente' in attributes) {
    if (attributes.importe_cliente === null) {
      operationModel.clienteImporte = 0;
    } else {
      operationModel.clienteImporte = attributes.importe_cliente;
    }
  }
  if ('cliente_renovable' in attributes) {
    operationModel.clienteRenovable = attributes.cliente_renovable ? 1 : 0;
  }
  if ('cliente_plazo_n' in attributes) {
    operationModel.clientePlazo = attributes.cliente_plazo_n;
  }
  if (relationships.cliente_plazo &&
    relationships.cliente_plazo.data &&
    relationships.cliente_plazo.data.id) {
    operationModel.clienteTipoPlazo = relationships.cliente_plazo.data.id;
  }
  if (relationships.cliente_cuota &&
    relationships.cliente_cuota.data &&
    relationships.cliente_cuota.data.id) {
    operationModel.clienteCuotas = relationships.cliente_cuota.data.id;
  }
  if (relationships.product &&
    relationships.product.data &&
    relationships.product.data.id) {
    operationModel.nexumProducto = relationships.product.data.id;
  }
  if (relationships.provision &&
    relationships.provision.data &&
    relationships.provision.data.id) {
    operationModel.provision = relationships.provision.data.id;
  }
  if (relationships.rango_nexum &&
    relationships.rango_nexum.data &&
    relationships.rango_nexum.data.id) {
    operationModel.nexumRango = relationships.rango_nexum.data.id;
  }
  if ('importe_ofrecido' in attributes) {
    if (attributes.importe_ofrecido === null) {
      operationModel.nexumImporte = 0;
    } else {
      operationModel.nexumImporte = attributes.importe_ofrecido;
    }
  }
  if ('interes_anual' in attributes) {
    if (attributes.interes_anual === null) {
      operationModel.nexumInteres = 0;
    } else {
      operationModel.nexumInteres = attributes.interes_anual;
    }
  }
  if ('ltv' in attributes) {
    if (attributes.ltv === null) {
      operationModel.nexumLTV = 0;
    } else {
      operationModel.nexumLTV = attributes.ltv;
    }
  }
  if ('comision_apertura' in attributes) {
    if (attributes.comision_apertura === null) {
      operationModel.nexumComision = 0;
    } else {
      operationModel.nexumComision = attributes.comision_apertura;
    }
  }
  if ('honorarios_colaborador' in attributes) {
    if (attributes.honorarios_colaborador === null) {
      operationModel.nexumHonorariosColaborador = 0;
    } else {
      operationModel.nexumHonorariosColaborador = attributes.honorarios_colaborador;
    }
  }
  if ('honorarios_intermediacion' in attributes) {
    if (attributes.honorarios_intermediacion === null) {
      operationModel.nexumHonorariosIntermediacion = 0;
    } else {
      operationModel.nexumHonorariosIntermediacion = attributes.honorarios_intermediacion;
    }
  }
  if ('renovable_nexum' in attributes) {
    operationModel.nexumRenovable = attributes.renovable_nexum ? '1' : '0';
  }
  if ('interes_renovacion_nexum' in attributes) {
    if (attributes.interes_renovacion_nexum === null) {
      operationModel.nexumInteresRenovacion = 0;
    } else {
      operationModel.nexumInteresRenovacion = attributes.interes_renovacion_nexum;
    }
  }
  if ('plazo_n' in attributes) {
    operationModel.nexumPlazo = attributes.plazo_n;
  }
  if ('created' in attributes) {
    operationModel.created = attributes.created;
  }
  if (relationships.plazo_periodo &&
    relationships.plazo_periodo.data &&
    relationships.plazo_periodo.data.id) {
    operationModel.nexumTipoPlazo = relationships.plazo_periodo.data.id;
  }
  if (relationships.cuota &&
    relationships.cuota.data &&
    relationships.cuota.data.id) {
    operationModel.nexumCuotas = relationships.cuota.data.id;
  }
  if ('gestoriza' in attributes) {
    operationModel.nexumGestoriza = attributes.gestoriza;
  }
  if ('gestion' in attributes) {
    operationModel.gestionVenta = attributes.gestion ? 1 : 0;
  }
  if ('exc' in attributes) {
    operationModel.gestionExclusiva = attributes.exc;
  }
  if ('honorarios_intermediacion_inmobi' in attributes) {
    if (attributes.honorarios_intermediacion_inmobi === null) {
      operationModel.gestionHonorarios = 0;
    } else {
      operationModel.gestionHonorarios = attributes.honorarios_intermediacion_inmobi;
    }
  }
  if ('perfil_cliente' in attributes) {
    operationModel.perfil = attributes.perfil_cliente;
  }
  if ('motivo' in attributes) {
    operationModel.motivo = attributes.motivo;
  }
  if ('forma_devolucion' in attributes) {
    operationModel.devolucion = attributes.forma_devolucion;
  }
  if (relationships.plazo_periodo &&
    relationships.plazo_periodo.data &&
    relationships.plazo_periodo.data.id) {
    operationModel.tipoPlazo = relationships.plazo_periodo.data.id;
  }
  if (relationships.dates_assigments &&
    relationships.dates_assigments.data &&
    relationships.dates_assigments.data.id) {
    operationModel.datesAssigments = relationships.dates_assigments.data.id;
  }
  if (relationships.state &&
    relationships.state.data &&
    relationships.state.data.id) {
    operationModel.state = relationships.state.data.id;
  }
  if (relationships.expenses &&
    relationships.expenses.data &&
    relationships.expenses.data.id) {
    operationModel.expenses = relationships.expenses.data.id;
  }
  if (relationships.volume &&
    relationships.volume.data &&
    relationships.volume.data.id) {
    operationModel.volume = relationships.volume.data.id;
  }
  if (relationships.prereport &&
    relationships.prereport.data &&
    relationships.prereport.data.id) {
    operationModel.prereport = relationships.prereport.data.id;
  }
  if (relationships.report &&
    relationships.report.data &&
    relationships.report.data.id) {
    operationModel.report = relationships.report.data.id;
  }
  if (relationships.documents_needed &&
    relationships.documents_needed.data &&
    relationships.documents_needed.data.length > 0) {
    operationModel.documentsNeeded = relationships.documents_needed.data.map(d => d.id);
  }
  if (relationships.documents &&
    relationships.documents.data &&
    relationships.documents.data.length > 0) {
    operationModel.documents = relationships.documents.data.map(d => d.id);
  }
  if (relationships.letras_operation &&
    relationships.letras_operation.data &&
    relationships.letras_operation.data.length > 0) {
    operationModel.letras = relationships.letras_operation.data.map(d => d.id);
  }
  if (relationships.cesiones &&
    relationships.cesiones.data &&
    relationships.cesiones.data.length > 0) {
    operationModel.cesiones = relationships.cesiones.data.map(d => d.id);
  }
  if (relationships.uid &&
    relationships.uid.data &&
    relationships.uid.data.id) {
    operationModel.creatorId = relationships.uid.data.id;
  }
  return operationModel;
};

export const formatOperationPatchLetras = (operationModel) => {
  if (operationModel.letras) {
    const data = [];
    operationModel.letras.forEach((id) => {
      data.push({
        type: 'node--instancia_letra',
        id,
      });
    });
    return data;
  }
  return [];
};

export const formatOperationPatchCesiones = (operationModel) => {
  if (operationModel.cesiones) {
    const data = [];
    operationModel.cesiones.forEach((id) => {
      data.push({
        type: 'node--cesion',
        id,
      });
    });
    return data;
  }
  return [];
};

export const formatOperationPatchClients = (operationModel) => {
  if (operationModel.clients) {
    const data = [];
    operationModel.clients.forEach((id) => {
      data.push({
        type: 'node--client',
        id,
      });
    });
    return data;
  }
  return [];
};

export const formatOperationPatchPledges = (operationModel) => {
  if (operationModel.pledges && operationModel.pledges.length > 0) {
    const data = [];
    operationModel.pledges.forEach((id) => {
      data.push({
        type: 'node--pledge',
        id,
      });
    });
    return data;
  }
  return [];
};

export const formatOperationPatchDocuments = (operationModel) => {
  if (operationModel.documents && operationModel.documents.length > 0) {
    const data = [];
    operationModel.documents.forEach((id) => {
      data.push({
        type: 'node--document',
        id,
      });
    });
    return data;
  }
  return [];
};

export const formatOperationPatchDocumentsNeeded = (operationModel) => {
  if (operationModel.documentsNeeded && operationModel.documentsNeeded.length > 0) {
    const data = [];
    operationModel.documentsNeeded.forEach((id) => {
      data.push({
        type: 'node--document',
        id,
      });
    });
    return data;
  }
  return [];
};

export const formatOperation = (operationModel) => {
  const attributes = {};
  const relationships = {};
  if (operationModel.title) {
    attributes.title = operationModel.title;
  }
  if (operationModel.clienteProducto) {
    relationships.producto_cliente = {
      data: {
        id: operationModel.clienteProducto,
        type: 'taxonomy_term--client_product',
      },
    };
  }
  if (operationModel.clienteRango) {
    relationships.rango_cliente = {
      data: {
        id: operationModel.clienteRango,
        type: 'taxonomy_term--rango_cargas',
      },
    };
  }
  if (operationModel.fichaComercial) {
    relationships.ficha_comercial = {
      data: {
        id: operationModel.fichaComercial,
        type: 'node--business_card',
      },
    };
  }
  if (operationModel.gestionInmobiliaria) {
    relationships.gestion_inmobiliaria = {
      data: {
        id: operationModel.gestionInmobiliaria,
        type: 'node--realty_management',
      },
    };
  }
  if (operationModel.clienteImporte) {
    attributes.importe_cliente = operationModel.clienteImporte;
  }
  if (operationModel.clienteRenovable) {
    attributes.cliente_renovable = operationModel.clienteRenovable;
  }
  if (operationModel.clientePlazo) {
    attributes.cliente_plazo_n = operationModel.clientePlazo;
  }
  if (operationModel.interesDemora) {
    attributes.interes_demora = operationModel.interesDemora;
  }
  if (operationModel.clienteTipoPlazo) {
    relationships.cliente_plazo = {
      data: {
        id: operationModel.clienteTipoPlazo,
        type: 'taxonomy_term--date',
      },
    };
  }
  if (operationModel.clienteCuotas) {
    relationships.cliente_cuota = {
      data: {
        id: operationModel.clienteCuotas,
        type: 'taxonomy_term--cuotas',
      },
    };
  }
  if (operationModel.nexumProducto) {
    relationships.product = {
      data: {
        type: 'taxonomy_term--product',
        id: operationModel.nexumProducto,
      },
    };
  }
  if (operationModel.nexumRango) {
    relationships.rango_nexum = {
      data: {
        type: 'taxonomy_term--rango_cargas',
        id: operationModel.nexumRango,
      },
    };
  }
  if (operationModel.nexumImporte) {
    attributes.importe_ofrecido = operationModel.nexumImporte;
  }
  if (operationModel.nexumInteres) {
    attributes.interes_anual = operationModel.nexumInteres;
  }
  if (operationModel.nexumLTV) {
    attributes.ltv = operationModel.nexumLTV;
  }
  if (operationModel.nexumComision) {
    attributes.comision_apertura = operationModel.nexumComision;
  }
  if (operationModel.nexumHonorariosColaborador) {
    attributes.honorarios_colaborador = operationModel.nexumHonorariosColaborador;
  }
  if (operationModel.nexumHonorariosIntermediacion) {
    attributes.honorarios_intermediacion = operationModel.nexumHonorariosIntermediacion;
  }
  if ('nexumRenovable' in operationModel) {
    attributes.renovable_nexum = operationModel.nexumRenovable === '1';
  }
  if (operationModel.nexumInteresRenovacion) {
    attributes.interes_renovacion_nexum = operationModel.nexumInteresRenovacion;
  }
  if (operationModel.preApproval) {
    attributes.pre_approval = operationModel.preApproval;
  }
  if ('nexumPlazo' in operationModel) {
    attributes.plazo_n = operationModel.nexumPlazo;
  }
  if (operationModel.nexumTipoPlazo) {
    relationships.plazo_periodo = {
      data: {
        type: 'taxonomy_term--date',
        id: operationModel.nexumTipoPlazo,
      },
    };
  }
  if (operationModel.nexumCuotas) {
    relationships.cuota = {
      data: {
        type: 'taxonomy_term--cuotas',
        id: operationModel.nexumCuotas,
      },
    };
  }
  if ('nexumGestoriza' in operationModel) {
    attributes.gestoriza = operationModel.nexumGestoriza;
  }
  if ('gestionVenta' in operationModel) {
    attributes.gestion = operationModel.gestionVenta === 1;
  }
  if ('gestionExclusiva' in operationModel) {
    attributes.exc = operationModel.gestionExclusiva;
  }
  if ('gestionHonorarios' in operationModel) {
    attributes.honorarios_intermediacion_inmobi = operationModel.gestionHonorarios;
  }
  if (operationModel.perfil) {
    attributes.perfil_cliente = operationModel.perfil;
  }
  if (operationModel.motivo) {
    attributes.motivo = operationModel.motivo;
  }
  if (operationModel.devolucion) {
    attributes.forma_devolucion = operationModel.devolucion;
  }
  if (operationModel.draft) {
    attributes.draft = operationModel.draft;
  }
  if (operationModel.lastUser) {
    attributes.last_user = operationModel.lastUser;
  }
  if (operationModel.tipoGestion === 0 || operationModel.tipoGestion === 1) {
    attributes.gestion = operationModel.tipoGestion;
  }
  if (operationModel.motivo) {
    attributes.motivo = operationModel.motivo;
  }
  if (operationModel.devolucion) {
    attributes.forma_devolucion = operationModel.devolucion;
  }
  if (operationModel.datesAssigments) {
    relationships.dates_assigments = {
      data: {
        type: 'node--date_assignement',
        id: operationModel.datesAssigments,
      },
    };
  }
  if (operationModel.preReport) {
    relationships.prereport = {
      data: {
        type: 'node--prereport',
        id: operationModel.preReport,
      },
    };
  }
  if (operationModel.report) {
    relationships.report = {
      data: {
        type: 'node--report',
        id: operationModel.report,
      },
    };
  }
  if (operationModel.volume) {
    relationships.volume = {
      data: {
        type: 'node--volume',
        id: operationModel.volume,
      },
    };
  }
  if (operationModel.provision) {
    relationships.provision = {
      data: {
        type: 'node--provision',
        id: operationModel.provision,
      },
    };
  }
  if (operationModel.expenses) {
    relationships.expenses = {
      data: {
        type: 'node--expenses',
        id: operationModel.expenses,
      },
    };
  }
  if (operationModel.state) {
    relationships.state = {
      data: {
        type: 'taxonomy_term--status',
        id: operationModel.state,
      },
    };
  }
  if (operationModel.clients) {
    relationships.clients = {
      data: formatOperationPatchClients(operationModel),
    };
  }
  if (operationModel.pledges && operationModel.pledges.length > 0) {
    relationships.pledge = {
      data: formatOperationPatchPledges(operationModel),
    };
  }
  if (operationModel.documents && operationModel.documents.length > 0) {
    relationships.documents = {
      data: formatOperationPatchDocuments(operationModel),
    };
  }
  if (operationModel.documentsNeeded && operationModel.documentsNeeded.length > 0) {
    relationships.documents_needed = {
      data: formatOperationPatchDocumentsNeeded(operationModel),
    };
  }
  if (operationModel.letras && operationModel.letras.length > 0) {
    relationships.letras_operation = {
      data: formatOperationPatchLetras(operationModel),
    };
  }
  if (operationModel.cesiones && operationModel.cesiones.length > 0) {
    relationships.cesiones = {
      data: formatOperationPatchCesiones(operationModel),
    };
  }
  return {
    data: {
      id: operationModel.id,
      type: 'node--operation',
      attributes,
      relationships,
    },
  };
};

export const formatDatesAssigments = (datesAssigmentsModel) => {
  const attributes = {};
  const relationships = {};
  if (datesAssigmentsModel.title) {
    attributes.title = datesAssigmentsModel.title;
  }
  if (datesAssigmentsModel.operationEntry) {
    attributes.f_entrada = DateTime.fromISO(datesAssigmentsModel.operationEntry).toISODate();
  }
  if (datesAssigmentsModel.operationSignature) {
    attributes.f_firma_deseada = DateTime.fromISO(datesAssigmentsModel.operationSignature).toISODate();
  }
  if (datesAssigmentsModel.financesSignature) {
    attributes.f_firma_financiera = DateTime.fromISO(datesAssigmentsModel.financesSignature).toISODate();
  }
  /* if (datesAssigmentsModel.notarySignature) {
    attributes.f_firma_notario = DateTime.fromISO(datesAssigmentsModel.notarySignature).toISODate();
  } */
  /* relationships */
  if (datesAssigmentsModel.colaborador) {
    relationships.colaborador = {
      data: {
        type: 'node--collaborator',
        id: datesAssigmentsModel.colaborador,
      },
    };
  }
  if (datesAssigmentsModel.analistaDDC) {
    relationships.analista = {
      data: {
        type: 'node--employee',
        id: datesAssigmentsModel.analistaDDC,
      },
    };
  }
  if (datesAssigmentsModel.analistaDRC) {
    relationships.analista_drc = {
      data: {
        type: 'node--employee',
        id: datesAssigmentsModel.analistaDRC,
      },
    };
  }
  if (datesAssigmentsModel.juridico) {
    relationships.juridico = {
      data: {
        type: 'node--employee',
        id: datesAssigmentsModel.juridico,
      },
    };
  }
  if (datesAssigmentsModel.cancela) {
    relationships.cancela = {
      data: {
        type: 'node--employee',
        id: datesAssigmentsModel.cancela,
      },
    };
  }
  if (datesAssigmentsModel.comercial) {
    relationships.comercial = {
      data: {
        type: 'node--employee',
        id: datesAssigmentsModel.comercial,
      },
    };
  }
  if (datesAssigmentsModel.financiero) {
    relationships.financiero = {
      data: {
        type: 'node--employee',
        id: datesAssigmentsModel.financiero,
      },
    };
  }
  if (datesAssigmentsModel.formaliza) {
    relationships.formaliza = {
      data: {
        type: 'node--employee',
        id: datesAssigmentsModel.formaliza,
      },
    };
  }
  const id = 'id' in datesAssigmentsModel ? datesAssigmentsModel.id : null;
  return {
    data: {
      id,
      type: 'node--date_assignement',
      attributes,
      relationships,
    },
  };
};

export const processDatesAssigmentsResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(dates => processDatesAssigments(dates));
  }
  return processDatesAssigments(res.data.data);
};

export const processOperationResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(operation => processOperation(operation, processOperationIncluded(operation, res.data.included)));
  }
  return processOperation(res.data.data, processOperationIncluded(res.data.data, res.data.included));
};



// WEBPACK FOOTER //
// ./src/features/operation/utils.js